/**
 * @module use-cases/search/actions
 * @desc Search Action Creators
 *
 */

import type { Search } from 'core/domains';
import { createAction, createAsyncAction } from 'core/use-cases/utilities';

export const searchSubmit = createAction<'searchSubmit'>('searchSubmit');

export const searchCleanUp = createAction<'searchCleanUp'>('searchCleanUp');

export const searchFetch = createAsyncAction<
  'searchFetch',
  Search['queryOptions']['query'],
  Search
>('searchFetch');
